import React, { useState } from 'react';
import { PortfolioProvider } from './context/PortfolioContext';
import { Navbar } from './components/common/Navbar';
import { HeroSection } from './components/hero/HeroSection';
import { AboutSection } from './components/about/AboutSection';
import { ProjectsSection } from './components/projects/ProjectsSection';
import { ProjectDetailModal } from './components/projects/ProjectDetailModal';
import { SkillsSection } from './components/skills/SkillsSection';
import { ExperienceTimeline } from './components/experience/ExperienceTimeline';
import { ContactSection } from './components/contact/ContactSection';
import { DigitalResumeModal } from './components/common/DigitalResumeModal';
import { ToastContainer } from './components/common/ToastContainer';
import { Footer } from './components/common/Footer';
import { BackgroundCanvas } from './components/common/BackgroundCanvas';
import { CustomCursor } from './components/common/CustomCursor';
import { LoadingScreen } from './components/common/LoadingScreen';

export const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <PortfolioProvider>
      <div className="app">
        {isLoading && <LoadingScreen onComplete={() => setIsLoading(false)} />}
        <BackgroundCanvas />
        <CustomCursor />
        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <ProjectsSection />
          <SkillsSection />
          <ExperienceTimeline />
          <ContactSection />
        </main>
        <Footer />

        {/* Dynamic Modals & Toasts */}
        <ProjectDetailModal />
        <DigitalResumeModal />
        <ToastContainer />
      </div>
    </PortfolioProvider>
  );
};

export default App;
